import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'users',
        url: '/users',
        component: 'wtUsersState',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer]),
            license: Resolve.licenseResolve
        },
        data: {
            visible: true,
            sortingOrder: 101,
            icon: 'fa-users',
            displayName: 'Users',
            editRoles: [Roles.superAdministrator],
            editButtonVisibility: () => true
        }
    }];

export default states;